import React, { ComponentProps, FunctionComponent } from "react";

const ArrowLeftIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 12",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M6.44444 1L2 6M2 6L6.44444 11M2 6H12",
      stroke: "currentColor",
      strokeWidth: 1.5,
    })
  );
};

const ForwardRef = React.forwardRef(ArrowLeftIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
